module.exports = __webpack_public_path__ + "static/010-0806768761eaaef941c9d4707676c11f.jpg";